<template>
    <div>
        <div class="row gx-3">
            <div class="col">
                <pc-label
                    v-bind:label="label"
                    v-bind:show-help="showHelp"
                    v-bind:help-link="showHelpLinkOnly"
                    class="mt-2 me-3"
                    v-on:help-clicked="emitHelpClicked" />
                <pc-button
                    v-bind:id="inputId"
                    v-bind:disabled="adapterConfigId == null || readonly || adapterDisabled"
                    data-test-role="btn"
                    data-gtmid="EditProject-WebAdapterCall"
                    v-on:click="CallAdapterConfig">
                    {{ buttonLabel }}
                </pc-button>
                <div
                    v-if="adapterDisabled"
                    class="text-danger fst-italic my-auto ms-1">
                    {{ disabledReason }}
                </div>
                <pc-help-icon
                    v-if="disabledHelpText"
                    class="my-auto ms-1"
                    v-on:click="showDisabledHelp = !showDisabledHelp" />
            </div>
        </div>
        <pc-alert
            v-model:shown="showDisabledHelp"
            v-bind:severity="helpSeverity"
            dismissible
            class="mt-2">
            {{ disabledHelpText }}
        </pc-alert>
        <div class="col-12 mt-2">
            <slot name="help" />
        </div>
    </div>
</template>

<script>
    import base from "./_elementBase";
    import { PROJECT_FORM_TYPES } from "../ProjectForm/projectFormStore";
    import { ALERT_SEVERITY } from "Util/alerts";
    import { GlobalEventBus } from "Util/emitter";

    export default {
        extends: base,
        data() {
            return {
                processing: false,
                showDisabledHelp: false,
                helpSeverity: ALERT_SEVERITY.warning
            };
        },
        computed: {
            label() {
                return this.element.Properties.label;
            },
            buttonLabel() {
                return this.element.Properties.buttonlabel;
            },
            adapterConfigId() {
                return this.element.AuxiliaryModel.AdapterConfigId;
            },
            adapterDisabled() {
                return this.element.AuxiliaryModel.AdapterDisabled;
            },
            disabledReason() {
                return this.element.AuxiliaryModel.DisabledReason;
            },
            disabledHelpText() {
                return this.element.AuxiliaryModel.DisabledHelpText;
            },
            readonly() {
                return this.baseReadonly || this.isPrefill;
            }
        },
        methods: {
            async CallAdapterConfig() {
                if (!this.isProjectModuleRegistered()) {
                    return;
                }
                try {
                    let callParameters = {
                        elementId: this.element.PublicId,
                        configurationId: this.element.Properties.adapterconfigid
                    };
                    // ALEX - Backward compatibility, remove after release
                    if (!this.element.Properties.adapterconfigid) {
                        callParameters = {
                            elementId: this.element.PublicId,
                            customizationId: this.element.Properties.webadapterid,
                            configurationId: this.adapterConfigId
                        };
                    }
                    // end backward compatibility
                    this.processing = true;
                    const result = await this.$store.dispatch(
                        PROJECT_FORM_TYPES.actions.callCustomization,
                        callParameters,
                        { root: true }
                    );
                    if (!result.Error) {
                        GlobalEventBus.emit("update_custom_lists");
                    }
                    if (result.Warning) {
                        this.$app.showDialog({
                            title: "Warning",
                            message: result.Warning,
                            buttons: [
                                {
                                    text: "OK",
                                    primary: true,
                                    result: "OK"
                                }
                            ]
                        });
                    }
                } finally {
                    this.processing = false;
                }
            }
        }
    };
</script>
